import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';

// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default function AuthGuard({ children }) {
  const { isAuthenticated, isWebVersion } = useAuth();

  if ( isWebVersion() ) {
    return <Navigate to="/" />;
  }

  if ( !isAuthenticated ) {
    return <Navigate to="/auth/login" />;
  }

  return <>{children}</>;
}